import { FETCH_COMPANY_LIST, RECEIVE_COMPANY_LIST, FAILED_COMPANY_LIST}
from '../actions/aUser-CompanyList'

const defaultCompanyState = {
    companyListData: [],
    success: false,
    companyKML: '',
    lat: null,
    lng: null,
    link_logo: null
}

export function fetchCompanyList(state = defaultCompanyState, action){
    switch (action.type) {
        case FETCH_COMPANY_LIST:
            return ({companyListData: [], companyKML: '', success: false, link_logo: null, inProgress: true, lat: null, lng: null})
        case RECEIVE_COMPANY_LIST:
            return Object.assign({}, state, {companyListData: action.payload, companyKML: action.payload.result[0].kml_link, link_logo: action.payload.result[0].link_logo, inProgress: false, success: true, lat: action.payload.result[0].lat, lng:  action.payload.result[0].lon})
        case FAILED_COMPANY_LIST:
            return ({companyListData: [], companyKML: '', success: false, link_logo: null, inProgress: false, lat: null, lng: null})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/redUser-CompanyList.jsx